import { render, staticRenderFns } from "./wuliankanbanC.vue?vue&type=template&id=d802a628&scoped=true&"
import script from "./wuliankanbanC.vue?vue&type=script&lang=js&"
export * from "./wuliankanbanC.vue?vue&type=script&lang=js&"
import style0 from "./wuliankanbanC.vue?vue&type=style&index=0&id=d802a628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d802a628",
  null
  
)

export default component.exports